

import React from "react";
import { ReactComponent as UserDoctorIcon } from "../../../assets/icons/user-doctor.svg"; // adjust path if needed
import "../../../center admin css/centerAdmin.css"

type TeamMemberCardProps = {
  name: string;
  role: string;
};

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({ name, role }) => {
  return (
    <div className="team-card">
      <div className="team-card__icon" aria-hidden>
        <UserDoctorIcon width={24} height={24} fill="#00A8A8" /> {/* you can adjust size/color */}
      </div>
      <div className="team-card__content">
        <div className="team-card__name">{name}</div>
        <div className="team-card__role">{role}</div>
      </div>
    </div>
  );
};

export default TeamMemberCard;

